<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.25 13.8971L14.25 10.433C14.5833 10.2406 14.5833 9.75944 14.25 9.56699L8.25 6.10289C7.91667 5.91044 7.5 6.151 7.5 6.5359L7.5 13.4641C7.5 13.849 7.91667 14.0896 8.25 13.8971Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlayIcon',
  props: {
    fill: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
